import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

const data = [
  { name: 'No Prazo', value: 65, color: 'hsl(var(--accent-500))' },
  { name: 'Atraso 1-7d', value: 20, color: 'hsl(40 95% 55%)' },
  { name: 'Atraso 8-30d', value: 10, color: 'hsl(25 95% 55%)' },
  { name: 'Perda (+30d)', value: 5, color: 'hsl(var(--careful-500))' },
];

interface CustomTooltipProps {
  active?: boolean;
  payload?: Array<{
    name: string;
    value: number;
    payload: { color: string };
  }>;
}

function CustomTooltip({ active, payload }: CustomTooltipProps) {
  if (!active || !payload?.length) return null;

  const entry = payload[0];
  return (
    <div className="bg-card border border-border rounded-lg p-2 shadow-lg">
      <div className="flex items-center gap-2">
        <span 
          className="w-2 h-2 rounded-full" 
          style={{ backgroundColor: entry.payload.color }}
        />
        <span className="text-sm text-foreground font-medium">{entry.name}</span>
        <span className="text-sm font-bold text-foreground">{entry.value}%</span>
      </div>
    </div>
  );
}

export function AgingDonutChart() {
  return (
    <div className="p-5 rounded-2xl border bg-card h-full hover:shadow-lg transition-all duration-300 flex flex-col">
      {/* Header centralizado */}
      <div className="text-center mb-4">
        <h3 className="text-sm font-semibold text-foreground">Aging da Carteira</h3>
        <p className="text-xs text-muted-foreground">Distribuição por tempo de atraso</p>
      </div>
      
      {/* Gráfico Centralizado */}
      <div className="flex justify-center flex-1 items-center mb-4">
        <div className="relative w-40 h-40">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={75}
                paddingAngle={3}
                dataKey="value"
                animationDuration={800}
              >
                {data.map((entry, index) => (
                  <Cell key={index} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
            </PieChart>
          </ResponsiveContainer>
          
          {/* Center label */}
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-sm font-medium text-muted-foreground">Carteira</span>
          </div>
        </div>
      </div>
      
      {/* Legend em Grid 2x2 */}
      <div className="grid grid-cols-2 gap-2 max-w-xs mx-auto">
        {data.map((entry, index) => (
          <div key={index} className="flex items-center gap-2">
            <span 
              className="w-2.5 h-2.5 rounded-full flex-shrink-0" 
              style={{ backgroundColor: entry.color }}
            />
            <span className="text-xs text-muted-foreground truncate">{entry.name}</span>
            <span className="text-xs font-semibold text-foreground ml-auto">{entry.value}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}
